module.exports = __webpack_public_path__ + "img/1549607731.4f3d2ad6.jpg";